import axios from '../helpers/axios'
import { logError } from '../services';
import {
  IResponse,
  ICustomPage,
  ICustomPageUpdate,
  ICustomPageDetail,
  IDropdownResponse,
  ICustomPageSection
} from '../models';

export const getCustomPages = async (filters?: {
  name?: string;
  isActive?: boolean;
  sortBy?: string;
  sortDirection?: string;
  page?: number;
  perPage?: number | string;
}): Promise<IResponse<ICustomPage[]>> => {
  try {
    const { data } = await axios.get(`/api/custom-pages`, {
      params: filters
    });
    return data;
  } catch (error) {
    logError(error, 'getCustomPages failed');
    return Promise.reject(error);
  }
};

export const createCustomPage = async (post: ICustomPageUpdate): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/custom-pages`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'createCustomPage failed'
    );
    return error.response.data;
  }
};

export const getCustomPage = async (
  id: number | string,
  sectionsToLoad?: number | null
): Promise<ICustomPageDetail> => {
  try {
    const { data } = await axios.get(`/api/custom-pages/${id}`, {
      params: {
        sectionsToLoad
      }
    });
    return data;
  } catch (error) {
    logError(error, 'getCustomPage failed');
    return Promise.reject(error);
  }
};

export const getCustomPageSections = async (
  id: number | string,
  subSectionId: number
): Promise<ICustomPageSection[]> => {
  try {
    const { data } = await axios.get(`/api/custom-pages/${id}/sections/${subSectionId}`);
    return data;
  } catch (error) {
    logError(error, 'getCustomPage failed');
    return Promise.reject(error);
  }
};

export const updateCustomPage = async (
  id: number | string,
  post: ICustomPageUpdate
): Promise<any> => {
  try {
    const res = await axios.put(`/api/custom-pages/${id}`, post);
    return res;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'updateCustomPage failed'
    );
    return error.response;
  }
};

export const deleteCustomPage = async (id: number | string): Promise<any> => {
  try {
    const { data } = await axios.delete(`/api/custom-pages/${id}`);
    return data;
  } catch (error) {
    logError(error, 'deleteCustomPage failed');
    return error.response.data;
  }
};

export const getCustomPageTypes = async (): Promise<IDropdownResponse[]> => {
  try {
    const { data } = await axios.get(`/api/custom-pages/sections/types`);
    return data;
  } catch (error) {
    logError(error, 'getCustomPageTypes failed');
    return Promise.reject(error);
  }
};

export const sendHomeowersPortalFeedback = async (post: {
  name: string;
  email: string;
  plan: string;
  subdivision: string;
  closingMonthAndYear: string;
  comments: string;
}): Promise<any> => {
  try {
    const { data } = await axios.post(`/api/feedback`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'sendHomeowersPortalFeedback failed'
    );
    return error.response.data;
  }
};

export const createCustomPageImage = async (post: FormData): Promise<string> => {
  try {
    const { data } = await axios.post(`/api/custom-pages/images`, post);
    return data;
  } catch (error) {
    logError(
      {
        error,
        payload: post
      },
      'createCustomPageImage failed'
    );
    return error.response.data;
  }
};
